<template>
  <div id="app">

    <Nav></Nav>

    <main>
        <router-view/>
    </main>

    <Footer></Footer>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
main {
    padding: 20px;
    background-color: #f8f8f8;
    border-top: 1px SOLID #DDD;
    border-bottom: 1px SOLID #DDD;
}
/* QuillJS editor height rule is placed here because using a <style scoped>
 * in a component is not working. The height makes sure it fits within a
 * modal dialog without triggering vertical scroll on the modal if the content
 * gets too large */
#editor-sm { height: 320px; }
#editor-md { height: 400px; }

/* Well */
/* E.g.
<div class="noApplications" v-if="role.applications && role.applications.length === 0">
    <h3 class='title is-4'>There are no applications!</h3>
    <h4 class='subtitle is-6'>No students have applied to this position yet</h4>
    <p>Applications of students wishing to fill this position will appear here. We recommend you continue to expand your project page to pique interest,
        and network on your campus and on social media to spread the word!</p>
</div> */
div.well {
  background-color: #f7f7f7;
  text-align: center;
  padding: 20px;
  border: 1px SOLID #ddd;
  margin: 10px;
}
div.well p { width: 70%; margin: auto; }
</style>



// WEBPACK FOOTER //
// src/App.vue